export const ERROR_PERMISSION_DENIED = "PermissionDenied"
